import type { I18n } from '@hive/core/modules/i18n';
import type { useI18n } from '@hive/i18n';
import { track } from '@hive/track';
import { SettingsIcon } from '@blocksuite/icons/rc';

import { registerHiveCommand } from './registry';

export function registerHiveLanguageCommands({
  i18n,
  t,
}: {
  i18n: I18n;
  t: ReturnType<typeof useI18n>;
}) {
  // Display Language
  const disposables = i18n.languageList.map(language => {
    return registerHiveCommand({
      id: `hive:change-display-language-to-${language.name}`,
      label: `${t['com.hive.cmdk.hive.display-language.to']()} ${
        language.originalName
      }`,
      category: 'hive:settings',
      icon: <SettingsIcon />,
      preconditionStrategy: () =>
        i18n.currentLanguage$.value.key !== language.key,
      run() {
        track.$.cmdk.settings.changeAppSetting({
          key: 'language',
          value: language.name,
        });

        i18n.changeLanguage(language.key);
      },
    });
  });

  return () => {
    disposables.forEach(dispose => dispose());
  };
}
